
import { mapGetters, mapActions } from "vuex";
import { sanitize } from "~/common/sanitize.js";

export default {
  name: "CNotifications",

  props: {
    app: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters({
      notifications: "c-notifications/getNotificationsToShow",
      notificationsPosition: "c-notifications/getNotificationPosition",
    }),
  },

  watch: {
    notifications: {
      handler: function (notifications) {
        notifications.forEach((notification) => {
          if (notification.timeout) {
            setTimeout(() => {
              this.removeNotification(notification);
            }, notification.timeout);
          }
        });
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions({
      removeNotification: "c-notifications/removeNotification",
    }),

    sanitizeContent(content) {
      return sanitize(content, "");
    },
  },
};
